<template>
  <div></div>
</template>

<script>
export default {

  created() {

    // URL取得
    var url = new URL(window.location.href);

    // URLSearchParamsオブジェクト取得
    var params = url.searchParams;
    if (params.has('redirectUrl')) this.$cookies.set('redirectUrl', params.get('redirectUrl'))
    this.$cookies.set('storeId', params.get('storeId'))

    var channelId = ""
    var channelSecret = ""
    this.axios  
      .get(this.$store.state.baseUrl + "line/auth/" + params.get('storeId'))
      .then((response) => {console.log(response)
        channelId = response.data.channel_id
        this.$cookies.set('channelId', channelId)
        channelSecret = response.data.channel_secret
        // URL作成
        var lineAuthorizeUrl = this.$store.state.line_platform.url1 + channelId + this.$store.state.line_platform.url2 + this.$store.state.line_platform.redirect_uri + this.$store.state.line_platform.url3 + channelSecret + this.$store.state.line_platform.url4;

        // LINE PLATFORMへ遷移
        window.location.href = lineAuthorizeUrl
      })
      .catch((e) => {
        return
      });
  },

};
</script>
